import { createAction, props } from '@ngrx/store';

import { type EngineStateBase } from '@blaze-runtime/engine-data-access';

const TAG = '[History]';

export const undo = createAction(`${TAG} Undo`, props<{ patch?: Partial<EngineStateBase> }>());
export const redo = createAction(`${TAG} Redo`, props<{ patch?: Partial<EngineStateBase> }>());
export const clearHistory = createAction(`${TAG} Clear History`);

export const requestUndo = createAction(`${TAG} Request Layout Undo`);
export const requestRedo = createAction(`${TAG} Request Layout Redo`);

export const setHistoryRestoring = createAction(
  `${TAG} Set History Restoring`,
  props<{ isRestoring: boolean }>(),
);

export const requestHistoryFail = createAction(`${TAG} Request Layout Fail`);

export const takeHistorySnapshot = createAction(`${TAG} Take History Snapshot`);
